// eslint-disable-next-line import/prefer-default-export
const SELECTED_ORG = 'selectedOrg';

export default {
  SELECTED_ORG,
};
